export default __webpack_public_path__ + "static/recycling-games-1ef02c0634bbf07dfbf5321b1931e286.jpg";